import { useEffect, useState } from "react"

import {
  Heading,
  InViewContainer,
  MobileStickyCta,
  Spinner,
} from "@trueskin-web/components"
import { Trans } from "@trueskin-web/translations"

import FullScreenOverlay from "../../shared/choose-plan/full-screen-overlay"
import withPresets from "../with-presets"

import Plan from "./plan"
import TogglePlans from "./toggle-plans"

const Plans = ({
  plans = [],
  selectedPlanId,
  isLoading,
  isSubmitting,
  error,
  onSelect,
  onSubmit,
}) => {
  const selectedPlan = plans.find((plan) => plan.id === selectedPlanId)

  const [activeFilter, setActiveFilter] = useState(
    selectedPlan?.instalments || 2
  )

  const handleFilterChange = (filter) => {
    setActiveFilter(filter)
  }

  const filteredPlans = plans
    .filter((plan) => plan.instalments === activeFilter)
    .sort((a, b) => b.isRecommended - a.isRecommended)

  const handleSubmit = () => {
    onSubmit(selectedPlanId)
  }

  useEffect(() => {
    if (selectedPlan) {
      setActiveFilter(selectedPlan.instalments)
    }
  }, [selectedPlan])

  if (isLoading) {
    return (
      <FullScreenOverlay>
        <Spinner isFullPage disableScroll />
      </FullScreenOverlay>
    )
  }

  if (error) {
    return (
      <FullScreenOverlay>
        <Trans i18Key="ChoosePlan.errorMessage" message={error.message} />
      </FullScreenOverlay>
    )
  }

  if (plans.length === 0) {
    return null
  }

  const discountPlan = filteredPlans.find((plan) => plan?.priceWithoutDiscounts)

  return (
    <InViewContainer
      sx={{
        mb: 4,
        "& > h3": {
          fontFamily: "display",
          lineHeight: "smallerHeading",
        },
      }}
    >
      {({ isInView }) => (
        <>
          <div
            sx={{
              width: ["100vw", "100%"],
              position: "relative",
              left: ["50%", 0],
              mr: [null, "auto"],
              ml: ["-50vw", 0],
              display: "flex",
              flexDirection: "column",
              rowGap: 4,
              pt: "40px",
              pb: 6,
              px: 6,
              mt: 4,
              background: "white",
              borderRadius: "32px",
            }}
          >
            <Heading as="h3" sx={{ lineHeight: 1.333, fontWeight: "bold" }}>
              Wähle das Set, das perfekt zu Dir passt.
            </Heading>

            <TogglePlans
              activeFilter={activeFilter}
              onClick={handleFilterChange}
              isDiscounted={
                typeof discountPlan?.priceWithoutDiscounts === "number"
              }
            />

            {filteredPlans.map((plan) => (
              <Plan
                key={plan.id}
                plan={plan}
                selectedPlanId={selectedPlanId}
                onSelect={onSelect}
              />
            ))}
          </div>

          {!!selectedPlan && (
            <MobileStickyCta
              dataTestId="web-portal-plan-selection-mobile-cta"
              rounded
              show={isInView}
              title={
                selectedPlan.isSubscription
                  ? "Weiter mit Auto-Refill"
                  : `Weiter mit ${selectedPlan.title}`
              }
              onClick={handleSubmit}
              sx={{
                "& button:after": {
                  content: isSubmitting ? `""` : undefined,
                },
              }}
            />
          )}
        </>
      )}
    </InViewContainer>
  )
}

export default withPresets(Plans, true)
